import { map } from 'lodash'

const formatAliases = {
  "12`": "12\"",
  "Cd": "CD",
  "Digital Ep": "Digital EP",
  "Dvd": "DVD",
  "Ep": "EP",
  "Lp": "LP"
};

export const physicalFormatsFormatter = {
	formatPhysicalFormats
};

function formatPhysicalFormats(physicalFormats) {
  return physicalFormats.map(({ primary_format }) => ({
	label: formatAliases.hasOwnProperty(primary_format) ? formatAliases[primary_format] : primary_format,
	value: primary_format
  }));
}
